// extracted by mini-css-extract-plugin
export default {"loader_overlay":"Loader_loader_overlay__ncpzh","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0"};